import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AntdLocaleProvider from './AntdLocaleProvider';
import App from './App';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AntdLocaleProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AntdLocaleProvider>
  </React.StrictMode>
);
